import { useEffect, useRef, useState } from 'react'
import { LuArrowUpRight, LuMenu, LuX } from 'react-icons/lu'
import { useLocation } from 'react-router-dom'

const Header = () => {
    const [menuOpen, setMenuOpen] = useState(false)
    const { pathname } = useLocation()
    const sectionHref = (section) =>
        pathname === '/' ? `#${section}` : `/#${section}`
    const headerRef = useRef(null)
    const toggleRef = useRef(null)

    useEffect(() => {
        if (!menuOpen) return

        const dismissMenu = (event) => {
            if (event.type === 'keydown' && event.key === 'Escape') {
                setMenuOpen(false)
                toggleRef.current?.focus()
            } else if (
                event.type === 'pointerdown' &&
                !headerRef.current?.contains(event.target)
            ) {
                setMenuOpen(false)
            }
        }
        const closeOnResize = () => {
            if (window.innerWidth > 1060) setMenuOpen(false)
        }

        window.addEventListener('keydown', dismissMenu)
        window.addEventListener('pointerdown', dismissMenu)
        window.addEventListener('resize', closeOnResize)
        return () => {
            window.removeEventListener('keydown', dismissMenu)
            window.removeEventListener('pointerdown', dismissMenu)
            window.removeEventListener('resize', closeOnResize)
        }
    }, [menuOpen])

    return (
        <header className="site-header" ref={headerRef}>
            <div className="site-header__inner site-container">
                <a
                    href={sectionHref('home')}
                    className="site-brand"
                    onClick={() => setMenuOpen(false)}
                    aria-label="Josephine Nguyen, home"
                >
                    <img
                        src={`${process.env.PUBLIC_URL}/logo512.png`}
                        className="site-brand__logo"
                        alt=""
                        width="88"
                        height="88"
                    />
                    <span className="site-brand__copy">
                        <span className="site-brand__name">
                            Josephine Nguyen
                        </span>
                        <span className="site-brand__detail">
                            A little code. A lot of heart. ♥
                        </span>
                    </span>
                </a>
                <button
                    ref={toggleRef}
                    type="button"
                    className="menu-toggle"
                    aria-label={
                        menuOpen ? 'Close navigation' : 'Open navigation'
                    }
                    aria-expanded={menuOpen}
                    aria-controls="primary-navigation"
                    onClick={() => setMenuOpen(!menuOpen)}
                >
                    {menuOpen ? (
                        <LuX aria-hidden="true" />
                    ) : (
                        <LuMenu aria-hidden="true" />
                    )}
                </button>
                <nav
                    id="primary-navigation"
                    className={`site-nav${menuOpen ? ' site-nav--open' : ''}`}
                    aria-label="Main navigation"
                >
                    <a
                        href={sectionHref('projects')}
                        onClick={() => setMenuOpen(false)}
                    >
                        <span className="site-nav__index" aria-hidden="true">
                            01
                        </span>{' '}
                        My Projects
                    </a>
                    <a
                        href={sectionHref('about')}
                        onClick={() => setMenuOpen(false)}
                    >
                        <span className="site-nav__index" aria-hidden="true">
                            02
                        </span>{' '}
                        About Me
                    </a>
                    <a
                        href={sectionHref('resume')}
                        onClick={() => setMenuOpen(false)}
                    >
                        <span className="site-nav__index" aria-hidden="true">
                            03
                        </span>{' '}
                        Resume & CV
                    </a>
                    <a
                        href="mailto:the.josephine.nguyen@gmail.com"
                        className="site-nav__contact"
                        onClick={() => setMenuOpen(false)}
                    >
                        Let’s talk <LuArrowUpRight aria-hidden="true" />
                    </a>
                </nav>
            </div>
        </header>
    )
}

export default Header
